import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '@/firebase'
import { onAuthStateChanged } from 'firebase/auth'

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/pages/index.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/login.vue')
  },
  {
    path: '/signup',
    name: 'Signup',
    component: () => import('@/pages/signup.vue')
  },
  {
    path: '/invoice',
    name: 'Invoice',
    component: () => import('@/pages/invoice.vue')
  },
  {
    path: '/invoice/:id',
    name: 'InvoiceEdit',
    component: () => import('@/pages/invoice-edit.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/pages/dashboard/Home.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: () => import('@/pages/invoices.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/expenses',
    name: 'Expenses',
    component: () => import('@/pages/expenses.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: () => import('@/pages/settings/Settings.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/terms',
    name: 'Terms',
    component: () => import('@/pages/legal/Terms.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('@/pages/legal/Privacy.vue')
  },
  // Removed dedicated billing page; Stripe links are used directly from the menu.
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      return { el: to.hash }
    }
    return { left: 0, top: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  const isAuthenticated = await new Promise(resolve => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      unsubscribe()
      resolve(!!user)
    })
  })

  if (isAuthenticated && to.name === 'Login') {
    return next({ name: 'Home' })
  }

  const redirectToHomeWhenLoggedIn = ['index', 'Signup']
  if (isAuthenticated && redirectToHomeWhenLoggedIn.includes(String(to.name))) {
    return next({ name: 'Home' })
  }

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'Login' })
  }

  next()
})

export default router
